import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';

export default function LandingFooter() {
  return (
    <Box component="footer" sx={{ pb: 4, pt: 2 }}>
      <Container maxWidth="lg">
        <Divider sx={{ mb: 4 }} />
        <Typography
          variant="body2"
          align="center"
          sx={{ color: 'text.secondary' }}
        >
          &copy; {new Date().getFullYear()} Syllabex. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
}
